import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Home from './Home';
import Signup from './Signup';
import Admin from './Admin';
import Signin from './Signin';
import { Container, Navbar, Nav, NavDropdown,Button } from 'react-bootstrap';
import { Routes, Route, Link } from 'react-router-dom';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from './firebaseconfig'
function Navigationbar() {
  const navigate = useNavigate();
  const [authUser, setAuthUser] = useState(null);
  const [name, usename] = useState("Username");
  const location = useLocation();
  useEffect(() => {
    const listen = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthUser(user);
      } else {
        setAuthUser(null);
      }
    });

    return () => {
      listen();
    };
  }, []);

  const userSignOut = () => {
    signOut(auth)
      .then(() => {
        console.log("sign out successful");
        navigate("/")
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
  
      <Navbar bg="dark" variant="dark"> 
        <Container>
          <Navbar.Brand >Record_Manager_App</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link>
              <Link
                to="/"
                style={{
                  textDecoration: 'none',
                  color:
                    location.pathname === '/Home'
                      ? 'white'
                      : 'GrayText',
                }}
              >
                Home
              </Link>
            </Nav.Link>
            {authUser?<Nav.Link>
              <Link
                to="/Admin"
                style={{
                  textDecoration: 'none',
                  color:
                    location.pathname === '/Admin'
                      ? 'white'
                      : 'GrayText',
                }}
              >
                Admin
              </Link>
            </Nav.Link>:<></>}
          </Nav>
          <div  >
            <NavDropdown title={(authUser)?authUser.email:name} id="nav-dropdown" style={{ color: 'white' ,marginRight:'15%',width:"3%"}}>
              {authUser?<NavDropdown.Item eventKey="4.1">Profile</NavDropdown.Item>:<></>}
              <NavDropdown.Item eventKey="4.2">
                {authUser ? (
                  <>
                    <p varient="danger" onClick={userSignOut}>Sign out </p>
                  </>
                ) : (
                  <p><Link to="/Signin" style={{textDecoration:'none',color:'ButtonText'}}>Login</Link></p>)}
            </NavDropdown.Item>
            </NavDropdown>
          </div>

        </Container>
      </Navbar>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/Admin" element={<Admin />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/Signin" element={<Signin />} />
      </Routes>
    </>
  );
}

export default Navigationbar;
